module.exports = __webpack_public_path__ + "media/images/Clade-Logo-White-854a6d21dff85fbdf71bf9422e8720ef.svg";